import React, { useState } from 'react';
import Traits from 'components/business/Traits';
import TraitsDetails from 'components/business/traits/TraitsDetails';
import { useLocation } from 'react-router';
import TraitDialogs from 'components/business/traits/TraitDialogs';
import TraitDetailsSnpsDialogs from 'components/business/traits/TraitDetailsSnpsDialogs';

export const TraitsCtx = React.createContext({});
export const TraitsDetailsCtx = React.createContext({});

function TraitPageProvider(props) {
  const [ search, setSearch ] = useState('');
  const [ traits, setTraits ] = useState(undefined);
  const [ delTraitDialog, setdelTraitDialog ] = useState({ open: false, payload: undefined });
  const [ createTraitDialog, setcreateTraitDialog ] = useState({ open: false, payload: undefined });
  const [ delTraitDetailSnpsDialog, setdelTraitDetailSnpsDialog ] = useState({ open: false, payload: undefined });
  const [ createTraitDetailSnpsDialog, setcreateTraitDetailSnpsDialog ] = useState({ open: false, payload: undefined });

  const closedelTraitDialog = () => {
    setdelTraitDialog({ ...delTraitDialog, open: false });
  };
  const openDelTraitDialog = () => {
    setdelTraitDialog({ ...delTraitDialog, open: true });
  };

  const closecreateTraitDialog = () => {
    setcreateTraitDialog({ ...createTraitDialog, open: false });
  };

  const openCreateTraitDialog = () => {
    setcreateTraitDialog({ payload: undefined, open: true });
  };

  const closedelTraitDetailSnpsDialog = () => {
    setdelTraitDetailSnpsDialog({ ...delTraitDetailSnpsDialog, open: false });
  };

  const opendelTraitDetailSnpsDialog = () => {
    setdelTraitDetailSnpsDialog({ ...delTraitDetailSnpsDialog, open: true });
  };

  const closeCreateTraitDetailSnpsDialog = () => {
    setcreateTraitDetailSnpsDialog({ ...createTraitDetailSnpsDialog, open: false });
  };

  const openCreateTraitDetailSnpsDialog = () => {
    setcreateTraitDetailSnpsDialog({ payload: undefined, open: true });
  };

  const ctx = {
    search,
    setSearch,
    traits,
    setTraits,
    delTraitDialog,
    setdelTraitDialog,
    createTraitDialog,
    setcreateTraitDialog,
    closedelTraitDialog,
    openDelTraitDialog,
    closecreateTraitDialog,
    openCreateTraitDialog,
    delTraitDetailSnpsDialog,
    setdelTraitDetailSnpsDialog,
    closedelTraitDetailSnpsDialog,
    opendelTraitDetailSnpsDialog,
    createTraitDetailSnpsDialog,
    setcreateTraitDetailSnpsDialog,
    closeCreateTraitDetailSnpsDialog,
    openCreateTraitDetailSnpsDialog,
  };
  return (
    <TraitsCtx.Provider value={ ctx }>
      {props.children}
    </TraitsCtx.Provider>
  );
}

function TraitDetailsPageProvider(props) {
  const [ selectedTrait, setSelectedTrait ] = useState(undefined);
  const [ selectedSnp, setSelectedSnp ] = useState(undefined);
  const ctx = {
    selectedTrait,
    setSelectedTrait,
    selectedSnp,
    setSelectedSnp,
  };

  return (
    <TraitsDetailsCtx.Provider value={ ctx }>
      {props.children}
    </TraitsDetailsCtx.Provider>
  );
}

function TraitsPage() {
  const location = useLocation();
  const { search } = location;
  const id = new URLSearchParams(search).get('id');
  return (
    <TraitPageProvider>
      {
        id ? (
          <TraitDetailsPageProvider>
            <TraitsDetails id={ id } />
          </TraitDetailsPageProvider>
        ) : <Traits />
      }
      <TraitDialogs />
      <TraitDetailsSnpsDialogs />
    </TraitPageProvider>
  );
}

export default TraitsPage;
